/** Modal open/close with focus return and Escape to dismiss. */

export interface Modal {
  open(): void;
  close(): void;
  readonly isOpen: boolean;
}

export function createModal(root: HTMLElement, onOpen?: () => void): Modal {
  let opener: HTMLElement | null = null;

  function close(): void {
    if (root.hidden) return;
    root.hidden = true;
    opener?.focus();
    opener = null;
  }

  function open(): void {
    opener = document.activeElement as HTMLElement | null;
    root.hidden = false;
    onOpen?.();
    const focusable = root.querySelector<HTMLElement>(
      'button:not(:disabled), input:not(:disabled), select, textarea, [tabindex]',
    );
    focusable?.focus();
  }

  // Clicking the scrim closes; clicking the box does not.
  root.addEventListener('click', (event) => {
    if (event.target === root) close();
  });

  root.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      event.stopPropagation();
      close();
    }
  });

  return {
    open,
    close,
    get isOpen() {
      return !root.hidden;
    },
  };
}
